import React from 'react'
import PropTypes from 'prop-types'
import { languages } from '../../common/config'

class LanguagePicker extends React.Component {
  state = {
    showAll: false,
  }

  render() {
    const { field, itemClick } = this.props
    const { showAll } = this.state

    return (
      <div className="language-picker">
        {
          Object.keys(languages).map((key, index) => (
            (showAll || index < 7) &&
            <div
              key={key}
              onClick={() => itemClick(key)}
              className={`language-picker-item ${field.value === key ? 'active' : ''}`}
            >
              {
                index < 7 &&
                <img src={`/assets/images/flags/${key}.png`} alt={key} />
              }
              {languages[key].name}
            </div>
          ))
        }
        {
          !showAll &&
          <div
            onClick={() => this.setState({ showAll: true })}
            className="language-picker-item"
          >
            ...
          </div>
        }
      </div>
    )
  }
}

LanguagePicker.propTypes = {
  field: PropTypes.object.isRequired,
  itemClick: PropTypes.func.isRequired,
}

export default LanguagePicker



// WEBPACK FOOTER //
// ./src/browser/components/LanguagePicker.js